export default __webpack_public_path__ + "static/media/danial.36aeb3c3.jpeg";